export default class InstructionHand extends Phaser.Sprite {
  constructor({ game }) {
    super(game);
    this.loadTexture('instructions', 'finger_tap_icon');
    this.duration = 0;
  }

  update() {
    this.duration += this.game.time.elapsedMS;
    const targetAlpha = Math.sin(this.duration * 0.01) + 1;
    this.alpha = targetAlpha / 2;
  }
}
